var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.nft)?_c(_setup.NeoNftCard,{attrs:{"nft":_setup.nft,"placeholder":_setup.placeholder,"prefix":_setup.urlPrefix,"show-price":Number(_setup.nft?.price) > 0,"variant":_vm.variant,"unloackable-icon":_setup.unlockableIcon,"link":"nuxt-link","bind-key":"to"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }